import React from "react";
import CourbesStatChart from "./CourbesStatChart.jsx";

/**
 * Irrigation cumulée : cumul de chaque statistique, via CourbesStatChart.
 * Coché à l'ouverture : Moyen. Tableau : Moyen et Quantile 90.
 */
export default function IrrigationCumuleeChart({ data, xMax }) {
  return (
    <CourbesStatChart
      data={data}
      prefixe="irr"
      cleDate="date_affichage"
      unite="mm"
      nomAxe="Irrigation cumulée (mm)"
      statsParDefaut={["moy"]}
      statsTableau={["moy", "q90"]}
      cumul
      xMax={xMax}
    />
  );
}
